// GENERATE BY ../scripts/generate.js
// DON NOT EDIT IT MANUALLY
/* eslint-disable */
import React, { forwardRef, MutableRefObject } from 'react';
import { IconProps } from '../type';
import classNames from 'classnames';
import useConfig from '../../_util/useConfig';
import useSizeProps from '../useSizeProps';

const EllipsisIcon = (props: IconProps, ref: MutableRefObject<SVGSVGElement>) => {
  const { classPrefix } = useConfig();
  const { size, className: customClassName, style: customStyle, ...restProps } = props;
  const { className: sizeClassName, style: sizeStyle } = useSizeProps(size);
  const className = classNames(classPrefix + '-icon',classPrefix+'-icon-ellipsis', sizeClassName, customClassName);
  const style = { ...customStyle, ...sizeStyle }

  return (
    <svg ref={ref} className={className} style={style} {...restProps} viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><path fillOpacity=".9" fillRule="evenodd" d="M192 448C227.346224 448 256 476.653776 256 512 256 547.346224 227.346224 576 192 576 156.653776 576 128 547.346224 128 512 128 476.653776 156.653776 448 192 448ZM512 448C547.346224 448 576 476.653776 576 512 576 547.346224 547.346224 576 512 576 476.653776 576 448 547.346224 448 512 448 476.653776 476.653776 448 512 448ZM832 448C867.3462208 448 896 476.653776 896 512 896 547.346224 867.3462208 576 832 576 796.6537792 576 768 547.346224 768 512 768 476.653776 796.6537792 448 832 448Z"/></svg>
  )
};

EllipsisIcon.displayName = 'EllipsisIcon';

export default forwardRef<SVGSVGElement, IconProps>(EllipsisIcon);
